export const NAME = 'locations'

// API routes
export const GET_LOCATIONS_ROUTE = 'epsSearchLocations'
